import styled from 'styled-components';
import img from '../images/background.jpg';

export const MainWrap = styled.div`
  width: 600px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  background-image: url(${img});
  background-color: #9fdaef;
  background-repeat: no-repeat;
  @media (max-width: 600px) {
    width: 375px;
  }
`;
